import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "../../../lib/api";

const readKey = (uid) => `orx_support_notif_read_${uid || "anon"}`;
const loadRead = (uid) => { try { return new Set(JSON.parse(localStorage.getItem(readKey(uid)) || "[]")); } catch { return new Set(); } };
const saveRead = (uid, set) => localStorage.setItem(readKey(uid), JSON.stringify([...set].slice(-500)));

// Notifications are derived from active tickets: open = new, escalated = escalation, unread_staff = user reply.
export function deriveNotifs(items = []) {
  const out = [];
  for (const t of items) {
    if (t.status === "escalated") out.push({ key: `${t.id}:esc:${t.escalated_at || t.updated_at}`, kind: "escalated", ticket: t, at: t.escalated_at || t.updated_at });
    else if (t.status === "open") out.push({ key: `${t.id}:new`, kind: "new", ticket: t, at: t.created_at });
    else if (t.unread_staff) out.push({ key: `${t.id}:reply:${t.updated_at}`, kind: "reply", ticket: t, at: t.updated_at });
  }
  return out.sort((a, b) => String(b.at).localeCompare(String(a.at)));
}

export function useSupportNotifs(enabled, uid, pathname) {
  const [items, setItems] = useState([]); const [read, setRead] = useState(() => loadRead(uid)); const [loading, setLoading] = useState(false);
  const refresh = useCallback(() => {
    if (!enabled) return;
    setLoading(true);
    api.get("/platform/support/tickets", { params: { status: "active", limit: 50 } })
      .then((r) => setItems(deriveNotifs(r.data.items || []))).catch(() => {}).finally(() => setLoading(false));
  }, [enabled]);
  useEffect(() => { setRead(loadRead(uid)); }, [uid]);
  useEffect(() => { if (!enabled) return undefined; refresh(); const t = setInterval(refresh, 60000); return () => clearInterval(t); }, [enabled, refresh]);
  const mark = useCallback((keys) => setRead((prev) => { const n = new Set(prev); keys.forEach((k) => n.add(k)); saveRead(uid, n); return n; }), [uid]);
  const openId = pathname.match(/\/support\/tickets\/([^/]+)/)?.[1];
  useEffect(() => { if (openId) { const ks = items.filter((n) => n.ticket.id === openId && !read.has(n.key)).map((n) => n.key); if (ks.length) mark(ks); } }, [openId, items, read, mark]);
  const list = useMemo(() => items.map((n) => ({ ...n, read: read.has(n.key) })), [items, read]);
  return { items: list, unread: list.filter((n) => !n.read).length, loading, refresh, markRead: (k) => mark([k]), markAll: () => mark(items.map((n) => n.key)) };
}
